import {Component, EventEmitter, Injector, Input, Output} from '@angular/core'
import { AppComponentBase } from '@shared/common/app-component-base';
import { InvoiceHeader } from 'QrMena/models/qrmena-invoice-model';
@Component({
    selector:"qrmena-invoice-items",
    templateUrl:'./invoice-items.component.html',
    styleUrls:['./invoice-items-component.css']
})
export class InvoiceItemsComponent extends AppComponentBase{
    @Input() invoice:InvoiceHeader
    @Input()isShow:boolean
    @Output() handelChangeQty:EventEmitter<{qty:number,recordId:string}>=new EventEmitter<{qty:number,recordId:string}>()
    @Output() hidCanvas =new EventEmitter<boolean>(); 
        @Output() RemoveItem:EventEmitter<string>=new EventEmitter<string>()
        @Output() handelSaveInvoice:EventEmitter<boolean>=new EventEmitter<boolean>()
 constructor(injector: Injector,) {
        super(injector);
         
    }
       handelCloseCanvas() {
        this.hidCanvas.emit(false)
    }

    handelRemoveItem(input:string)
    {
            this.RemoveItem.emit(input)
    }
    handelChangeQtyClick(input:{qty:number,recordId:string}){
        this.handelChangeQty.emit(input)
    }
    handelSaveInvoiceClick()
    {
        this.handelSaveInvoice.emit(true);
    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/invoice-items-component/invoice-items.component.ts